import React from "react";
import Protected from "../../components/Protected";
import useIsLoggedIn from "../../shared/hooks/user/useIsLoggedIn";

type AuthGuardProps = {
  children: React.JSX.Element;
};

export default AuthGuard;

function AuthGuard(props: Readonly<AuthGuardProps>) {
  const isLoggedIn = useIsLoggedIn();
  return <Protected isAuthorized={isLoggedIn} outlet={props.children} />;
}
